// Map common MIME types to file extensions
const mimeToExtension: Record<string, string> = {
	'application/zip': 'zip',
	'application/pdf': 'pdf',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/vnd.ms-excel': 'xls',
	'text/csv': 'csv',
};

/**
 * Extract filename from Content-Disposition header
 */
export const getFilenameFromDisposition = (
	contentDisposition?: string
): string | null => {
	if (!contentDisposition) return null;
	const match = contentDisposition.match(/filename="?(.+?)"?$/);
	return match?.[1] ?? null;
};

/**
 * Get file extension based on Blob type
 */
export const getExtensionFromBlob = (blob: Blob): string => {
	return mimeToExtension[blob.type] || 'dat';
};

/**
 * Download a Blob as a file in browser
 * @param blob - The file content
 * @param contentDisposition - Optional Content-Disposition header
 * @param fallbackName - Fallback filename if backend header is missing
 */
export const downloadFile = (
	blob: Blob,
	contentDisposition?: string,
	fallbackName = 'download'
) => {
	//  backend filename if available
	let filename = getFilenameFromDisposition(contentDisposition);

	// If not available, use MIME type
	if (!filename) {
		const ext = getExtensionFromBlob(blob);
		filename = `${fallbackName}.${ext}`;
	}

	// temporary link to trigger download
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	link.click();

	// Clean up
	window.URL.revokeObjectURL(url);
};
